import React from 'react'
import { withProps } from 'recompose'
import { mapValues } from 'lodash'
import { FormattedMessage } from 'react-intl'
import {
  ADD_SPACE,
  DREAM_HOME,
  ELIMINATE_CREDIT_CARD_DEBT,
  EMERGENCY_RESERVE,
  EUROTRIP,
  EXPLORE_INVESTMENTS,
  HOME_IMPROVEMENT,
  RENTAL_PROPERTY,
  RENT_BUY,
  SELL_POCKET,
  SOLAR_PANELS,
  STUDENT_DEBT
} from 'src/constants/gems'
import {
  IconAda,
  IconCommentingFa,
  IconEmergency,
  IconGraduationCap,
  IconHomeImprovement,
  IconPlane,
  IconRentBuy,
  IconRentalHome,
  IconSellPocket,
  IconSolar,
  IconTradeUp,
  IconWallet
} from 'src/Components/shared/Icon'

import Gem from './Gem'

export const definitions = {
  [DREAM_HOME]: {
    title: (
      <FormattedMessage
        id='Homeowner.purchasePower.dreamHomeTitle'
        defaultMessage='Buy your dream home'
      />
    ),
    icon: IconTradeUp
  },
  [RENTAL_PROPERTY]: {
    title: (
      <FormattedMessage
        id='Homeowner.purchasePower.rentalPropertyTitle'
        defaultMessage='Buy an investment property'
      />
    ),
    icon: IconRentalHome
  },
  [RENT_BUY]: {
    title: (
      <FormattedMessage
        id='Homeowner.purchasePower.rentBuyTitle'
        defaultMessage='Rent your home & buy another'
      />
    ),
    icon: IconRentBuy
  },
  [SELL_POCKET]: {
    title: (
      <FormattedMessage
        id='Homeowner.purchasePower.sellPocketTitle'
        defaultMessage='Sell & pocket the cash'
      />
    ),
    icon: IconSellPocket
  },
  [EMERGENCY_RESERVE]: {
    icon: IconEmergency,
    title: (
      <FormattedMessage
        id='Homeowner.equity.emergenciesTitle'
        defaultMessage='Create an emergency fund'
      />
    )
  },
  [HOME_IMPROVEMENT]: {
    icon: IconHomeImprovement,
    title: (
      <FormattedMessage
        id='Homeowner.equity.homeImprovementTitle'
        defaultMessage='Make home improvements'
      />
    ),
    color: 'orange'
  },
  [ADD_SPACE]: {
    icon: IconAda,
    title: (
      <FormattedMessage
        id='Homeowner.equity.addSpaceTitle'
        defaultMessage='Add more livable space'
      />
    )
  },
  [ELIMINATE_CREDIT_CARD_DEBT]: {
    icon: IconWallet,
    title: (
      <FormattedMessage
        id='Homeowner.equity.creditCardDebtTitle'
        defaultMessage='Eliminate credit card debt'
      />
    )
  },
  [STUDENT_DEBT]: {
    icon: IconGraduationCap,
    title: (
      <FormattedMessage
        id='Homeowner.equity.studentDebtTitle'
        defaultMessage='Pay down student loans'
      />
    )
  },
  [SOLAR_PANELS]: {
    icon: IconSolar,
    title: (
      <FormattedMessage
        id='Homeowner.equity.solarPanelsTitle'
        defaultMessage='Add solar panels'
      />
    )
  },
  [EUROTRIP]: {
    color: 'red',
    icon: IconPlane,
    title: (
      <FormattedMessage
        id='Homeowner.equity.eurotripTitle'
        defaultMessage='Splurge on a European vacation'
      />
    )
  },
  [EXPLORE_INVESTMENTS]: {
    icon: IconCommentingFa,
    title: (
      <FormattedMessage
        id='Homeowner.equity.exploreInvestmentsTitle'
        defaultMessage='Explore new investments'
      />
    )
  }
}

export default mapValues(definitions, (props, key) => ({
  key,
  Gem: withProps(props)(Gem)
}))
